//  import React, { useState } from 'react'
//  import { Button, TextField, MenuItem, CircularProgress } from "@mui/material";
//  import { db } from "../Firebase/firebaseConfig";
//  import {
//    collection,
//    addDoc,
//    updateDoc,
//    doc,
//    serverTimestamp,
//  } from "firebase/firestore";



//  function CreateEvents() {
//      const[forms,setforms]=useState([])
//      const[events,setevents]=useState({
//      title:"",
//      booth:"",
//      location:"",
//      date:"",     tag:""

//  })

//      function handlechange(e){
//          setevents({
//              ...events,
//              [e.target.name]:e.target.value
            

//          })
        
//              }

//     async function handlesubmit(e){
//          e.preventDefault()
//           try {
//               await addDoc(collection(db, "events"), events)
//               alert("Sucess data added to firebase")
            
//           } catch (error) {
//              console.log(error);
            
            
//           }
//         setforms([...forms,events])
//         console.log(forms);
       
//      setevents({
//        title: "",       booth: "",
//        location: "",
//        date: "",
//        year: "",
//        tag: ""
//      });

//      }
//    return (

//   <form style={{ display: "flex", flexDirection: "column", gap: "16px" }} onSubmit={handlesubmit}>
      
//        <TextField label="Event title" fullWidth value={events.title} name='title' onChange={handlechange}/>

//        <TextField label="Booth name" fullWidth value={events.booth} name='booth' onChange={handlechange}/>

//        <TextField label="Location" fullWidth type='string' value={events.location} name='location' onChange={handlechange}/>
//        <TextField label="Date" fullWidth value={events.date} name='date' onChange={handlechange}/>
     
//        <TextField label="Tag" fullWidth  value={events.tag} name='tag' onChange={handlechange}/>

//        <TextField
//         label="Product Description"
//         fullWidth
//         multiline
//         rows={4}
//       /> 
 
//       <TextField select label="Category" fullWidth>
//         <MenuItem value="">Select Category</MenuItem>
//         <MenuItem value="chemical">Chemical</MenuItem>
//         <MenuItem value="pharma">Pharma</MenuItem>
//       </TextField> 

//         <div>
//          <label>Upload Image</label><br />
//          <input type="file" accept="image/*" />
//        </div>

//        <div>
//          <label>Attach Brochure</label><br />
//        <input type="file" />
//          </div>  

//        Placeholder for product details component /       <div>
//          <p><strong>Event Details </strong></p>
//        </div>

//        <Button type="submit" variant="contained" color="primary">
//          Add Event
//        </Button>
//      </form>

//    )
//  }

// export default CreateEvents

import React, { useEffect, useState } from "react";
import EventForm from "../Forms/EventForm";
import { db } from "../Firebase/firebaseConfig";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import AdminEventTable from "../Admin/AdminTables/EventTable";
import styles from "../Admin/CreateEvent.module.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toast } from "react-toastify";

// Event data type
export interface EventFormData {
  title: string;
  booth: string;
  location: string;
  date: string;

  tag: string;
  id?: string;
}

const ManageEvents: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState<string | null>(null);
  const [isError, setIsError] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [expanded, setExpanded] = useState(false);
  const [defaultValues, setDefaultValues] = useState<EventFormData>({
    title: "",
    booth: "",
    location: "",
    date: "",
    tag: "",
  });

  const handleSubmit = async (data: EventFormData) => {
    setIsLoading(true);
    setStatusMessage(isEdit ? "Updating event..." : "Creating event...");
    setIsError(false);

    const payload = {
      ...data,
      updatedAt: serverTimestamp(),
      ...(isEdit ? {} : { createdAt: serverTimestamp() }),
    };

    try {
      if (isEdit && editId) {
        await updateDoc(doc(db, "events", editId), payload);
        setStatusMessage("Event updated successfully!");
        toast.success("Event updated successfully!");
      } else {
        await addDoc(collection(db, "events"), payload);
        setStatusMessage("Event created successfully!");
        toast.success("Event created successfully!");
      }

      resetForm();
    } catch (error: any) {
      setIsError(true);
      setStatusMessage(`Error: ${error.message}`);
      toast.error(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (event: EventFormData & { id: string }) => {
    setDefaultValues(event);
    setIsEdit(true);
    setEditId(event.id);
    setExpanded(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setDefaultValues({
      title: "",
      booth: "",
      location: "",
      date: "",
      tag: "",
    });
    setIsEdit(false);
    setEditId(null);
  };

  useEffect(() => {
    if (isEdit) setExpanded(true);
  }, [isEdit]);

  return (
    <div className={styles.manageEventContainer}>
      <Accordion expanded={expanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={() => {
            setExpanded(!expanded);
            resetForm();
          }}
        >
          <Typography variant="h6">
            {isEdit ? "Edit Event" : "Add New Event"}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {statusMessage && (
            <p
              className={`${styles.statusMessage} ${
                isError ? styles.statusMessageError : styles.statusMessageSuccess
              }`}
            >
              {statusMessage}
            </p>
          )}

          {isLoading ? (
            <CircularProgress />
          ) : (
            <EventForm onSubmit={handleSubmit} defaultValues={defaultValues} />
          )}
        </AccordionDetails>
      </Accordion>

      <AdminEventTable onEdit={handleEdit} />
    </div>
  );
};

export default ManageEvents;

